import { Brand } from "../context/AppProvider";
import CLO from "../assets/clo.svg";
import CLOSET from "../assets/closet.svg";
import MD from "../assets/md.svg";
import CONNECT from "../assets/closet_connect.svg";
import React from "react";

type BrandIconProps = {
  brand: Brand;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
};

const BrandIcon = React.forwardRef<HTMLDivElement, BrandIconProps>(
  ({ brand, className, onClick }, ref) => {
    return (
      <div onClick={onClick} ref={ref}>
        {brand === Brand.CLO3D && (
          <img
            className={`h-[28px] w-[28px] ${className}`}
            src={CLO}
            alt="CLO"
          />
        )}
        {brand === Brand.CLOSET && (
          <img
            className={`h-[28px] w-[28px] ${className}`}
            src={CLOSET}
            alt="CLOSET"
          />
        )}
        {brand === Brand.CLOSET_CONNECT && (
          <img
            className={`h-[28px] w-[28px] ${className}`}
            src={CONNECT}
            alt="CLOSET CONNECT"
          />
        )}
        {brand === Brand.MD && (
          <img className={`h-[28px] w-[28px] ${className}`} src={MD} alt="MD" />
        )}
        {brand === Brand.ALLINONE && (
          <img
            className={`h-[28px] w-[28px] ${className}`}
            src={CLO}
            alt="ALLINONE"
          />
        )}
      </div>
    );
  },
);

export default BrandIcon;
